<script setup lang="ts">
import { defineProps, ref, defineEmits } from "vue";
import QuestionnaireButtonNext from "../parts/QuestionnaireButtonNext.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireTextArea from "../parts/QuestionnaireTextArea.vue";

type Props = {
  textAreaTitle: string;
  textAreaPlaceholder: string;
  prevButtonText: string;
  nextButtonText: string;
  height?: string;
  description?: string;
};

const props = defineProps<Props>();
type Emits = {
  (event: "onSubmit", description: string): void;
  (event: "onStepBack"): void;
};
const emits = defineEmits<Emits>();

const description = ref(props.description ? props.description : "");
const descriptionError = ref({
  isError: false,
  message: "",
});

const onSubmit = () => {
  if (description.value && description.value.trim()) {
    descriptionError.value.isError = false;
    descriptionError.value.message = "";
    emits("onSubmit", description.value);
  } else {
    descriptionError.value.message = "Description is required!";
    descriptionError.value.isError = true;
  }
};
</script>

<template>
  <div class="w-full flex flex-col justify-between">
    <div
      class="w-full pt-[24px] px-[32px] max-h-[calc(100vh-136px)] h-auto overflow-y-auto"
    >
      <div>
        <h2
          class="pb-2 text-xl leading-8 tracking-[0.01rem] font-semibold text-primary-text-color"
        >
          What data is missing? Please write here
        </h2>
        <div class="flex flex-col">
          <QuestionnaireTextArea
            v-model="description"
            :height="height"
            :placeholder="textAreaPlaceholder"
            :is-error="descriptionError.isError"
            :error-message="descriptionError.message"
          />
        </div>
      </div>
    </div>
    <div
      class="w-full flex items-center justify-between pt-3 mt-[46px] border-t border-black/15"
    >
      <div>
        <QuestionnaireButtonPrev
          @click="$emit('onStepBack')"
          :button-text="prevButtonText"
        />
      </div>
      <div>
        <QuestionnaireButtonNext
          :is-loading="false"
          @click="onSubmit"
          :button-text="nextButtonText"
        />
      </div>
    </div>
  </div>
</template>
